import React, { useState } from "react";
import { TextField, Button, Container, Typography, Box, Rating, CircularProgress } from "@mui/material";
import axiosInstance from "../config/axiosInstance";
import { API_ENDPOINTS } from "../config/apiConfig";

const Feedback = () => {
    const [formData, setFormData] = useState({ name: "", email: "", feedback: "", rating: 3 });
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");

        try {
            const response = await axiosInstance.post(API_ENDPOINTS.ADD_FEEDBACK, formData);
            if (response.data.code === "200" || response.data.code === "201") {
                setSubmitted(true);
            } else {
                setError("Something went wrong, please try again.");
            }
        } catch (error) {
            console.error("Error submitting feedback:", error);
            setError("Failed to submit feedback. Please check your network.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container maxWidth="sm">
            <Box mt={5} p={3} boxShadow={3} borderRadius={2} bgcolor="white">
                <Typography variant="h4" gutterBottom>Feedback</Typography>

                {submitted ? (
                    <Typography color="success.main">Thanks for your feedback!</Typography>
                ) : (
                    <form onSubmit={handleSubmit}>
                        <TextField
                            fullWidth label="Name" name="name" variant="outlined" margin="normal"
                            value={formData.name} onChange={handleChange} required
                        />
                        <TextField
                            fullWidth label="Email" name="email" variant="outlined" margin="normal"
                            value={formData.email} onChange={handleChange} required type="email"
                        />
                        <Typography variant="subtitle1" gutterBottom>Rate Your Experience</Typography>
                        <Rating
                            name="rating"
                            value={formData.rating}
                            onChange={(e, newValue) => setFormData({ ...formData, rating: newValue ?? 3 })}
                        />
                        <TextField
                            fullWidth label="Your Feedback" name="feedback" variant="outlined" margin="normal"
                            value={formData.feedback} onChange={handleChange} required multiline rows={4}
                        />

                        {error && <Typography color="error" mt={1}>{error}</Typography>}

                        <Button variant="contained" color="primary" type="submit" fullWidth disabled={loading}>
                            {loading ? <CircularProgress size={24} /> : "Submit Feedback"}
                        </Button>
                    </form>
                )}
            </Box>
        </Container>
    );
};

export default Feedback;
